import classes from '../../index.module.css';

import { Flash } from 'iconsax-react';

const marqueeItems = [
    'باتری به باتری رایگان',
    '۱۰٪ تخفیف خرید باتری',
    'سرویس در محل، هرجا که باشی',
    'اعزام فوری کارشناس در تهران',
    'باتری اصل با گارانتی معتبر'
];

const MarqueeStrip = () => {
    return (
        <section aria-hidden dir='ltr' className='overflow-hidden bg-amber-400 py-3'>
            <div className={classes.marquee}>
                {[...marqueeItems, ...marqueeItems, ...marqueeItems].map((item, index) => (
                    <span key={index} className='mx-7 flex items-center gap-2 whitespace-nowrap text-sm font-extrabold text-[#0A1530]'>
                        <Flash size={18} color='currentcolor' />
                        {item}
                    </span>
                ))}
            </div>
        </section>
    );
};

export default MarqueeStrip;
